// Estado global para gerenciar as imagens
let productImageState = {
    imgSrc: '',
    imgTitle: '',
    isVideo: ''
};

// Função para atualizar a imagem principal
function updateImageThumb(src, title, liElement) {
    productImageState.imgSrc = src;
    productImageState.imgTitle = title;
    
    const zoomContainer = document.querySelector('#product-photo .zoom');
    const mainLink = document.querySelector('#product-photo .zoom .lupa');
    
    // Verifica se o li tem data-video
    const videoUrl = liElement ? liElement.getAttribute('data-video') : null;
    const isYoutube = liElement ? (liElement.getAttribute('data-youtube') === 'true' || liElement.getAttribute('data-ytvideo') === 'true') : false;
    
    if (videoUrl) {
        const existingVideo = zoomContainer.querySelector('video');
        const existingIframe = zoomContainer.querySelector('iframe');
        const existingImage = zoomContainer.querySelector('img');
        
        // Remove a imagem se existir
        if (existingImage) {
            existingImage.remove();
        }
        
        if (isYoutube) {
            // Se for YouTube, cria um iframe
            if (existingIframe) {
                existingIframe.src = videoUrl;
                existingIframe.setAttribute('title', title);
            } else {
                // Remove vídeo se existir
                if (existingVideo) {
                    existingVideo.remove();
                }
                
                const iframe = document.createElement('iframe');
                iframe.src = videoUrl;
                iframe.setAttribute('title', title);
                iframe.setAttribute('frameborder', '0');
                iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
                iframe.setAttribute('allowfullscreen', 'true');
                iframe.style.width = '100%';
                iframe.style.height = '100%';
                
                // Insere o iframe antes do link da lupa
                if (mainLink) {
                    zoomContainer.insertBefore(iframe, mainLink);
                } else {
                    zoomContainer.appendChild(iframe);
                }
            }
            
            if (mainLink) {
                mainLink.href = videoUrl;
            }
        } else {
            // Se for vídeo normal, substitui a imagem por um elemento video
            // Remove iframe se existir
            if (existingIframe) {
                existingIframe.remove();
            }
            
            // Cria ou atualiza o elemento video
            if (existingVideo) {
                existingVideo.src = videoUrl;
                existingVideo.setAttribute('alt', title);
                existingVideo.setAttribute('title', title);
                existingVideo.muted = true; // Garante que está mudo
                existingVideo.setAttribute('muted', 'true');
                // Força o muted novamente após mudar o src
                existingVideo.addEventListener('loadedmetadata', function() {
                    this.muted = true;
                }, { once: true });
            } else {
                const video = document.createElement('video');
                video.src = videoUrl;
                video.alt = title;
                video.title = title;
                video.setAttribute('loop', 'true');
                video.setAttribute('autoplay', 'true');
                video.setAttribute('muted', 'true');
                video.setAttribute('playsinline', 'true');
                video.muted = true; // Define a propriedade diretamente
                video.controls = false; // Vídeo sem controles
                
                // Garante que o vídeo fique mudo após carregar
                video.addEventListener('loadedmetadata', function() {
                    this.muted = true;
                }, { once: true });
                
                // Insere o video antes do link da lupa
                if (mainLink) {
                    zoomContainer.insertBefore(video, mainLink);
                } else {
                    zoomContainer.appendChild(video);
                }
            }
            
            if (mainLink) {
                mainLink.href = videoUrl;
            }
        }
        
        productImageState.isVideo = videoUrl;
    } else {
        // Se for imagem, mantém o comportamento atual
        const existingVideo = zoomContainer.querySelector('video');
        const existingIframe = zoomContainer.querySelector('iframe');
        const mainImage = zoomContainer.querySelector('img');
        
        // Remove o vídeo e iframe se existirem
        if (existingVideo) {
            existingVideo.remove();
        }
        if (existingIframe) {
            existingIframe.remove();
        }
        
        // Cria a imagem se não existir
        if (!mainImage) {
            const img = document.createElement('img');
            img.src = src;
            img.alt = title;
            img.title = title;
            
            // Insere a imagem antes do link da lupa
            if (mainLink) {
                zoomContainer.insertBefore(img, mainLink);
            } else {
                zoomContainer.appendChild(img);
            }
        } else {
            mainImage.src = src;
            mainImage.alt = title;
            mainImage.title = title;
        }
        
        if (mainLink) {
            mainLink.href = src;
        }
        
        productImageState.isVideo = '';
    }
    
    // Atualiza a classe active em todos os thumbs (incluindo clones)
    const allThumbs = document.querySelectorAll('#photo-list li');
    allThumbs.forEach(thumb => {
        const thumbVideo = thumb.getAttribute('data-video');
        const thumbImg = thumb.querySelector('img');
        
        // Verifica se é o thumb ativo comparando vídeo, YouTube ou imagem
        if (liElement && thumb === liElement) {
            thumb.classList.add('active');
        } else if (videoUrl && thumbVideo === videoUrl) {
            thumb.classList.add('active');
        } else if (thumbImg && thumbImg.src === src) {
            thumb.classList.add('active');
        } else {
            thumb.classList.remove('active');
        }
    });
    
    // Atualiza o estado do Vue para compatibilidade
    const vueInstance = document.querySelector('#product-detail').__vue__;
    if (vueInstance) {
        vueInstance.imgSrc = src;
        vueInstance.imgTitle = title;
        vueInstance.isVideo = videoUrl || '';
    }
}

// Função para inicializar os event listeners dos thumbs
function initializeThumbListeners() {
    // Usa event delegation para funcionar com clones do Slick
    document.addEventListener('click', function(event) {
        const clickedThumb = event.target.closest('#photo-list li');
        if (clickedThumb) {
            const videoUrl = clickedThumb.getAttribute('data-video');
            const thumbImg = clickedThumb.querySelector('img');
            
            if (videoUrl) {
                // Se for vídeo, usa o título da imagem ou do produto
                const title = thumbImg ? thumbImg.title : (thumbImg ? thumbImg.alt : '');
                updateImageThumb(videoUrl, title, clickedThumb);
            } else if (thumbImg) {
                updateImageThumb(thumbImg.src, thumbImg.title, clickedThumb);
            }
        }
    });
}

// Função para inicializar a primeira imagem
function initializeFirstImage() {
    const photoList = document.getElementById("photo-list");
    if (photoList) {
        const firstLi = photoList.querySelector("li");
        if (firstLi) {
            const videoUrl = firstLi.getAttribute('data-video');
            const imgElement = firstLi.querySelector("img");
            
            if (videoUrl) {
                const title = imgElement ? imgElement.title : (imgElement ? imgElement.alt : '');
                updateImageThumb(videoUrl, title, firstLi);
            } else if (imgElement) {
                updateImageThumb(imgElement.src, imgElement.title, firstLi);
            }
        }
    }
}

new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#product-detail',
    data: {
        // Showcase
        showOpened: false,
        expandDesc: false,
        installmentOpened: false,
        expandedDescriptions: [],

        //Thumb - mantido para compatibilidade com Vue
        imgSrc: '',
        imgTitle: '',
        isVideo: ''
    },
    methods: {
        resizeThumbs() {
            const contentThumbs = document.querySelector('#product-photo');
            const imgThumb = document.querySelector('#product-photo img');
            const videoThumb = document.querySelector('#product-photo video');
            const iframeThumb = document.querySelector('#product-photo iframe');
            const mediaElement = imgThumb || videoThumb || iframeThumb;
            if (contentThumbs && mediaElement) {
                let heightMedia = mediaElement.getBoundingClientRect().height;
                contentThumbs.style.minHeight = heightMedia + 'px';
            }
        },
        clickThumbs() {
            let photoArea = document.querySelector('.product-detail__header--photoArea');
            let photoThumbs = document.querySelector('.product-detail__header--photoArea-thumbs');

            if (photoThumbs && photoArea) {
                if (photoArea.classList.contains('gallery-left') || photoArea.classList.contains('gallery-right') || photoArea.classList.contains('gallery-bottom')) {

                    let photoListItem = document.querySelectorAll('#photo-list li');
                    let singlePhotoItem = document.querySelectorAll('#product-photo img');

                    if (photoListItem.length && singlePhotoItem.length) {
                        photoListItem[0].classList.add('active');
                        singlePhotoItem[0].classList.add('active');

                        function activeTab(index) {
                            singlePhotoItem.forEach((content) => {
                                content.classList.remove('active');
                            });
                            singlePhotoItem[index].classList.add('active');
                        }

                        photoListItem.forEach((itemMenu, index) => {
                            itemMenu.addEventListener('click', () => {
                                activeTab(index);
                            });
                        });
                    }
                }
            }

            if (photoThumbs && photoArea) {
                if (photoThumbs.classList.contains('gallery-left') || photoThumbs.classList.contains('gallery-right')) {
                    $('#photo-list').slick({
                        infinite: false,
                        slidesToShow: 5,
                        slidesToScroll: 1
                    });
                }
            }
        },
        updateImageThumb(src) {
            // Mantido para compatibilidade, mas agora usa a função nativa
            const thumbImg = document.querySelector(`#photo-list li img[src="${src}"]`);
            if (thumbImg) {
                const liElement = thumbImg.closest('li');
                updateImageThumb(src, thumbImg.title, liElement);
            }
        },

        setThumbHeight() {
            return document.querySelector('.product-detail__header--photoArea-thumbs').style.height = document.querySelector('#photo-list li.visible').clientHeight * this.slidesToShow + 'px;';
        },

        handleESC(event) {
            if (event.key === 'Escape')
                this.showOpened = false
        },

        checkBuyView() {
            const buyButton = document.getElementById("js-product_button_add_to_cart__product_detail_");
            const rect = buyButton.getBoundingClientRect();

            if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                const otherElement = document.querySelector(".product-detail__fixedBtn");

                if (otherElement) {
                    otherElement.classList.remove("active");
                }
            } else {
                const otherElement = document.querySelector(".product-detail__fixedBtn");

                if (otherElement) {
                    otherElement.classList.add("active");
                }
            }
        },

        moveToBuy() {
            var productSize = document.querySelector(".infoArea__variation--kit");

            if (productSize) {
                productSize.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        },

        zoom(event) {
            const container = document.querySelector('#product-photo .zoom');
            const image = document.querySelector('#product-photo .zoom img');

            if (!container || !image) return;

            const containerRect = container.getBoundingClientRect();
            const mouseX = event.clientX - containerRect.left;
            const mouseY = event.clientY - containerRect.top;

            if (mouseX >= 0 && mouseX <= containerRect.width && mouseY >= 0 && mouseY <= containerRect.height) {
                const zoomLevel = 1.5;
                
                // Calcula a posição relativa do mouse (0 a 1)
                const relativeX = mouseX / containerRect.width;
                const relativeY = mouseY / containerRect.height;
                
                // Calcula o offset baseado na posição relativa
                const maxOffsetX = (container.offsetWidth * zoomLevel - container.offsetWidth) / 2;
                const maxOffsetY = (container.offsetHeight * zoomLevel - container.offsetHeight) / 2;
                
                const offsetX = -maxOffsetX + (relativeX * maxOffsetX * 2);
                const offsetY = -maxOffsetY + (relativeY * maxOffsetY * 2);

                image.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${zoomLevel})`;
            }
        },

        resetZoom() {
            const image = document.querySelector('#product-photo .zoom img');
            if (image) {
                image.style.transform = 'translate(0, 0) scale(1)';
            }
        },

        clickThumbsMosaic() {
            const thumbs = document.querySelector('.product-detail__header--photoArea-thumbs-default');
            const photos = document.querySelector('#product-photo ul');
            if (thumbs) {
                thumbs.addEventListener('click', function (event) {
                    if (event.target.classList.contains('product-detail__header--photoArea-mobile-img')) {
                        const eventPhoto = event.target.closest('.sp-wrap');
                        const targetPhoto = photos.querySelector(`#${eventPhoto.id}`);
                        if (targetPhoto) {
                            const offset = (window.innerHeight / 2) - (targetPhoto.offsetHeight / 2);
                            const elementPosition = targetPhoto.getBoundingClientRect().top + window.scrollY;

                            window.scrollTo({
                                top: elementPosition - offset,
                                behavior: 'smooth'
                            });
                        }
                    }
                })
            }
        },

        toggleDescription(id) {
            if (this.expandedDescriptions.includes(id)) {
                this.expandedDescriptions = this.expandedDescriptions.filter(descId => descId !== id);
            } else {
                this.expandedDescriptions.push(id);
            }
        }
    },
    mounted() {

        // Inicializa as funções nativas para os thumbs
        initializeThumbListeners();
        initializeFirstImage();

        // Adicionar event listeners
        const zoomContainer = document.querySelector('#product-photo .zoom');
        if (zoomContainer) {
            zoomContainer.addEventListener('mousemove', this.zoom.bind(this));
            zoomContainer.addEventListener('mouseleave', this.resetZoom.bind(this));
        }

        const installmentsClick = document.querySelectorAll('.product-installment__section');
        const intallmentsTable = document.querySelector('.installment-table');
        if (installmentsClick && intallmentsTable) {
            installmentsClick.forEach(item => {
                item.addEventListener('click', () => {
                    intallmentsTable.classList.toggle('active');
                });
            });
            intallmentsTable.addEventListener('click', () => {
                intallmentsTable.classList.toggle('active');
            });
        }

        const customSelects = document.querySelectorAll('.custom-select-container.cores .custom-select');

        customSelects.forEach(select => {
            const display = select.querySelector('.select-display');
            const dropdown = select.querySelector('.select-dropdown');
            const searchInput = select.querySelector('.select-search');
            const options = select.querySelectorAll('.select-options li');

            // Adiciona texto inicial baseado na opção selecionada
            const selectedOption = select.querySelector('.select-options .selected');
            if (selectedOption) {
                display.textContent = selectedOption.textContent; // Define o texto inicial do display
            } else {
                display.textContent = ''; // Se não houver seleção, mantém vazio
            }

            // Mostra/oculta o dropdown ao clicar
            display.addEventListener('click', () => {
                select.classList.toggle('active');
                dropdown.style.display = select.classList.contains('active') ? 'block' : 'none';
                searchInput.value = ''; // Limpa a busca ao abrir
                filterOptions(''); // Reseta o filtro
            });

            // Fecha o dropdown ao clicar fora
            document.addEventListener('click', (event) => {
                if (!select.contains(event.target)) {
                    select.classList.remove('active');
                    dropdown.style.display = 'none';
                }
            });

            // Filtra opções com base na busca
            searchInput.addEventListener('input', () => {
                const filter = searchInput.value.toLowerCase();
                filterOptions(filter);
            });

            // Filtra as opções com base no texto da busca
            function filterOptions(filter) {
                options.forEach(option => {
                    const text = option.textContent.toLowerCase();
                    option.style.display = text.includes(filter) ? '' : 'none';
                });
            }

            // Seleciona uma opção ao clicar
            options.forEach(option => {
                option.addEventListener('click', () => {
                    display.textContent = option.textContent; // Atualiza o texto exibido
                    select.classList.remove('active');
                    dropdown.style.display = 'none';
                    // Redireciona para o URL do produto
                    window.location.href = option.dataset.value; // Redireciona para o URL do produto
                });
            });
        });

        this.resizeThumbs();
        this.clickThumbs();
        this.clickThumbsMosaic();

        // Atualiza o estado do Vue para compatibilidade
        const photoList = document.getElementById("photo-list");
        if (photoList) {
            const firstLi = photoList.querySelector("li");
            if (firstLi) {
                const imgElement = firstLi.querySelector("img");

                if (imgElement) {
                    this.imgSrc = imgElement.getAttribute("src");
                    this.imgTitle = imgElement.getAttribute("title");
                }
            }
        }

        const ratingName = document.querySelector('.product-detail__rating__amount');
        if (ratingName !== null)
            if (ratingName.textContent === 'Seja o primeiro a avaliar')
                ratingName.textContent = 'Avaliar';

        const userLetterElement = document.getElementById('user_letter');
        if (userLetterElement) {
            const userLetter = userLetterElement.innerText.trim();
            if (userLetter.length > 0) {
                userLetterElement.innerText = userLetter[0];
            }
        }

        document.addEventListener('keydown', this.handleESC, { passive: true });
        window.addEventListener("scroll", this.checkBuyView, { passive: true });
        window.addEventListener("load", this.checkBuyView, { passive: true });
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleESC);
    },
    watch: {
        showOpened(newValue) {
            if (newValue) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.removeProperty('overflow');
            }
        },
    }
})

$(document).ready(function () {

    $('#photo-list').slick({
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        infinite: true,
        swipeToSlide: true,
        touchMove: true,
    }).on('afterChange', function(event, slick, currentSlide) {
        // Clica no slide que está com a classe slick-current
        const currentSlideElement = $(this).find('.slick-current');
        if (currentSlideElement.length) {
            currentSlideElement.trigger('click');
        }
    }).on('init', function() {
        // Reinicializa os listeners após o Slick ser inicializado
        setTimeout(() => {
            initializeFirstImage();
        }, 100);
    });

    waitForElementToExist('#photo-list .slick-dots').then(element => {
        setTimeout(function() {
            const photoList = $('#photo-list');
            const dotsContainer = photoList.find('.slick-dots');
            const prevArrow = photoList.find('.slick-prev');
            const nextArrow = photoList.find('.slick-next');
            
            if (dotsContainer.length && (prevArrow.length || nextArrow.length)) {
                if (prevArrow.length) {
                    // Move a prev arrow para o início do container
                    prevArrow.prependTo(dotsContainer);
                }
                if (nextArrow.length) {
                    // Move a next arrow para o final do container
                    nextArrow.appendTo(dotsContainer);
                }
            }
        }, 100);
        
    });

    $(shipping_service).bind("onSuccessGetShippingProduct", function (event, data, cep_destino, produto_id, textStatus, jqXHR) {
        const itemFreight = document.querySelectorAll('#js_shipping_calculation_table_body tr');
        if (itemFreight.length) {
            itemFreight.forEach(item => {
                let resumeValue = item.querySelector('.product-detail__table__column .value-line-through + span');
                if (resumeValue.textContent == 'R$ 0.00') {
                    resumeValue.textContent = 'Grátis';
                }
            });
        }
    });

    const scrollContainer = document.getElementById('photo-list');
    const progressBar = document.getElementById('progressBar');

    scrollContainer.addEventListener('scroll', () => {
        const scrollLeft = scrollContainer.scrollLeft;
        const scrollWidth = scrollContainer.scrollWidth - scrollContainer.clientWidth;
        const progress = (scrollLeft / scrollWidth) * 100;
        progressBar.style.width = `${progress}%`;
    });

    window.addEventListener('load', () => {
        const scrollLeft = scrollContainer.scrollLeft;
        const scrollWidth = scrollContainer.scrollWidth - scrollContainer.clientWidth;
        const progress = (scrollLeft / scrollWidth) * 100;
        progressBar.style.width = `${progress}%`;
    });

    let isDown = false;
    let startX;
    let scrollLeft;

    scrollContainer.addEventListener('mousedown', (e) => {
        isDown = true;
        scrollContainer.classList.add('dragging');
        startX = e.pageX - scrollContainer.offsetLeft;
        scrollLeft = scrollContainer.scrollLeft;
    });

    scrollContainer.addEventListener('mouseleave', () => {
        isDown = false;
        scrollContainer.classList.remove('dragging');
    });

    scrollContainer.addEventListener('mouseup', () => {
        isDown = false;
        scrollContainer.classList.remove('dragging');
    });

    scrollContainer.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - scrollContainer.offsetLeft;
        const walk = (x - startX) * 1.5;
        scrollContainer.scrollLeft = scrollLeft - walk;
    });


    var inputImage = document.querySelectorAll('.inputfile');
    if (inputImage) {
        inputImage.forEach((item) => {
            item.addEventListener("change", function (e) {
                var file = item.files[0];

                if (!file) return; // Se nenhum arquivo for selecionado, sai da função.

                var label = item.nextElementSibling;
                var spanLabel = label.querySelector("span");

                // Atualiza o nome do arquivo corretamente
                spanLabel.textContent = file.name;

                // Verifica se o tipo do arquivo é válido
                if (!["image/png", "image/gif", "image/jpeg"].includes(file.type)) {
                    alert("Formato inválido. Escolha um arquivo PNG, GIF ou JPEG.");
                    item.value = ""; // Reseta o input para evitar arquivos inválidos
                    spanLabel.textContent = "Nenhum arquivo selecionado";
                    return;
                }

                var reader = new FileReader();
                reader.readAsDataURL(file);

                reader.onload = function () {
                    item.setAttribute("base64", reader.result); // Usa `.setAttribute` corretamente
                };

                reader.onerror = function (error) {
                    console.log("Erro ao carregar o arquivo:", error);
                };
            });
        });
    }

    const photoArea = document.querySelector(".product-detail__header--photoArea");
    const infoArea = document.querySelector(".product-detail__header--infoArea");

    if (photoArea) {
        const customSelect = photoArea.querySelector(".custom-select-container");
        if (customSelect) {
            customSelect.remove();
        }
    }

    if (infoArea) {
        const complements = infoArea.querySelector(".complements");
        if (complements) {
            complements.remove();
        }
    }

    $('.product-rating__review-list').slick({
        dots: false,
        arrows: true,
        infinite: false,
        autoplay: false,
        adaptiveHeight: true,
        speed: 1000,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    var $slider = $('.product-rating__review-list');
    var $progressBar = $('.product-detail__ratings--progress');

    $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var slideIndex = nextSlide !== undefined ? nextSlide + 2 : 1;
        var calc = (slideIndex / slick.slideCount) * 100;

        $progressBar
            .css('background-size', calc + '% 100%')
            .attr('aria-valuenow', calc);
    });

    const brinde = document.querySelector('#js_buy_together_api_layout_2');

    if (brinde) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                        if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                            const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                        if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                            const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                    }
                });
            });
        });

        observer.observe(brinde, {
            childList: true,
            subtree: true
        });

    }

    const galleryCarrousel = document.querySelector('.gallery-carrousel');
    if (galleryCarrousel) {
        $('#product-photo').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            speed: 1000,
            vertical: false,
        });
    }

    $('.product-detail__header--photoArea-mobile').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: false,
        mobileFirst: true,
        speed: 700,
        vertical: false,
        responsive: [
            {
                breakpoint: 991,
                settings: "unslick"
            },
        ]
    });

    $('#product-detail-related-carrousel').slick({
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 700,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    arrows: true,
                    dots: false,
                    slidesToShow: 4,
                }
            }
        ]
    });

    $('#product-detail-related-carrousel').on('afterChange', function (event, slick, currentSlide, nextSlide) {
        Blazy({
            selector: '.lazy-img',
            successClass: 'loaded-img',
            success: function (element) {
                setTimeout(function () {
                    var parent = element.previousSibling;
                    try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                }, 200);
            }
        });
    });

    $('#photo-fancy').fancybox();

    const headers = document.querySelectorAll('.product-detail__header--infoArea-description-tab h2');
    const descriptions = document.querySelectorAll('.description');

    headers.forEach(header => {
        header.addEventListener('click', () => {
            headers.forEach(h => h.classList.remove('active'));
            descriptions.forEach(description => description.classList.remove('active'));

            header.classList.add('active');

            const index = header.getAttribute('data-index');

            const activeDescription = document.querySelector(`.description[data-index="${index}"]`);
            activeDescription.classList.add('active');
        });
    });
})